(function(){
  // Sync the dot indicator to the currently visible slide.
  // Uses IntersectionObserver scoped per .cl-card__media-track so
  // dozens of cards on a collection page don't bog down scroll.
  function init(track){
    if (track.__cubDotInit) return;
    track.__cubDotInit = true;
    var wrap = track.parentElement;
    var dots = wrap.querySelectorAll('.cl-card__dot');
    var slides = track.querySelectorAll('.cl-card__media-slide');
    if (!slides.length) return;

    // 1. Sync dots to scroll position via IO
    if (dots.length) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting || e.intersectionRatio < 0.6) return;
          var idx = Array.prototype.indexOf.call(slides, e.target);
          if (idx < 0) return;
          dots.forEach(function(d, i){
            d.classList.toggle('is-active', i === idx);
          });
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function(s){ io.observe(s); });
    }

    // 2. Cancel click-navigation if the user swiped (touch drag > 8px horizontally)
    var startX = 0, startY = 0, moved = false;
    track.addEventListener('touchstart', function(e){
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      moved = false;
    }, { passive: true });
    track.addEventListener('touchmove', function(e){
      var dx = Math.abs(e.touches[0].clientX - startX);
      var dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > 8 || dy > 8) moved = true;
    }, { passive: true });
    // Capture click in capture phase so we can stop it before the <a> handler
    track.addEventListener('click', function(e){
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    // 3. Same for mouse (desktop drag)
    var mDown = false, mStartX = 0, mMoved = false;
    track.addEventListener('mousedown', function(e){
      mDown = true; mStartX = e.clientX; mMoved = false;
    });
    track.addEventListener('mousemove', function(e){
      if (mDown && Math.abs(e.clientX - mStartX) > 6) mMoved = true;
    });
    track.addEventListener('mouseup', function(){ mDown = false; });
    track.addEventListener('click', function(e){
      if (mMoved) { e.preventDefault(); e.stopPropagation(); mMoved = false; }
    }, true);
  }

  function scan(){
    document.querySelectorAll('.cl-card__media-wrap--multi .cl-card__media-track').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Pick up cards added later (infinite scroll, filter updates)
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function(){
      // debounced: scan once per animation frame
      if (mo.__pending) return;
      mo.__pending = true;
      requestAnimationFrame(function(){ mo.__pending = false; scan(); });
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
    else document.addEventListener('DOMContentLoaded', function(){
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }
})();